module.exports = __webpack_public_path__ + "img/secure-user.ea85c308.svg";